import axios from "axios"

function setAuthorizationHeader(token: string | null = null) {
    if (token) {
        axios.defaults.headers.common["x-auth-token"] = token
        axios.defaults.headers.common["token"] = token
        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`
    } else {
        delete axios.defaults.headers.common["x-auth-token"]
        delete axios.defaults.headers.common["token"]
        delete axios.defaults.headers.common["Authorization"]
    }
}

// Adding token to the header
export { setAuthorizationHeader }
